module.exports = __webpack_public_path__ + "img/cefta.54b2dd12.svg";